/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Login_Resetpasswordhint2Inputs */



/**

* @param {_Login_Resetpasswordhint2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _login_resetpasswordhint2 = /** @type {((inputs?: _Login_Resetpasswordhint2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Login_Resetpasswordhint2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Bitte geben Sie hier Ihre E-Mail oder Nutzernamen ein. Sie werden in Kürze eine Mail erhalten. Sie enthält einen Link, mit dem Sie Ihr Passwort einmalig zurücksetzen können. Er ist nur wenige Stunden gültig.")
});
export { _login_resetpasswordhint2 as "_login_resetPasswordHint" }